import React from "react";
import SignaturePad from "react-signature-canvas";
import SignatureCanvas from "react-signature-canvas";
import { useAtendimentoPage } from "../../../Context/AtendimentoPage";
import { InserirDocumentoDiretoEmCasoController } from "../../../Controllers/Geral/CasoDocumentos/CasoDocumentosController";
import { DocumentoCasoContaController } from "../../../Controllers/Geral/Documentos/DocumentosController";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { IAtendimentoExtraDetalhado } from "../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";
import { Spinner } from "../../Loding/SpinnerPadrao";
import OrSpinner from "../../Utils/OrSpinner";

interface IBlocoAssinaturaAssistenciaTecnicaProps {
    idCaso: number;
}

const imagemInicial =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAAtJREFUGFdjYAACAAAFAAGq1chRAAAAAElFTkSuQmCC";

export default function BlocoAssinaturaAssistenciaTecnica(
    props: IBlocoAssinaturaAssistenciaTecnicaProps
) {
    const AtendimentoPage = useAtendimentoPage();
    const Atendimento =
        AtendimentoPage.Atendimento as IAtendimentoExtraDetalhado;
    const padRef = React.useRef<SignatureCanvas>(null);

    const { execute: salvarAssinatura, loading: salvarAssinaturaLoading } =
        useAsyncCallback(InserirDocumentoDiretoEmCasoController);

    const trim = () => {
        const url = padRef.current?.getTrimmedCanvas().toDataURL("image/png");
        if (url) {
            const splitedUrl = url.split(",");
            if (splitedUrl[1].length > 800) {
                salvarAssinatura({
                    ID_CASO: props.idCaso,
                    IM_DOCUMENTO: splitedUrl[1],
                    DS_TIPO: "image/png",
                    ID_TIPO_DOCUMENTO: 12,
                    DS_DOCUMENTO: `Assinatura_Assistencia_Tecnica_${props.idCaso}_${Atendimento.NR_ETAPA}.png`,
                }).then(() => {
                    AtendimentoPage.updateAtendimento();
                });
            }
        }
    };

    const clear = () => {
        padRef.current?.clear();
    };

    const {
        value: assinaturaFormulario,
        loading: assinaturaFormularioLoading,
    } = useAsyncEffect(async () => {
        return DocumentoCasoContaController(
            0,
            `Assinatura_Assistencia_Tecnica_${props.idCaso}_7.png`,
            props.idCaso
        );
    }, [salvarAssinaturaLoading]);

    const assinaturaFormularioImg = assinaturaFormulario?.IM_DOCUMENTO
        ? assinaturaFormulario.IM_DOCUMENTO
        : assinaturaFormulario?.DS_LINK_DRIVE;

    function handleFormatoSRC() {
        const splitedLink = assinaturaFormulario?.DS_LINK_DRIVE
            ? assinaturaFormulario?.DS_LINK_DRIVE
            : assinaturaFormulario?.DS_LINK_DRIVE;

        const split = splitedLink?.split("/");
        const driveFileId = split ? split[split.length - 2] : "00";

        if (assinaturaFormulario?.IM_DOCUMENTO) {
            return `data:image/png;base64,${assinaturaFormulario.IM_DOCUMENTO}`;
        } else if (assinaturaFormulario?.DS_LINK_DRIVE) {
            return `https://docs.google.com/uc?id=${driveFileId}`;
        }
    }

    return (
        <OrSpinner loading={assinaturaFormularioLoading} spinner="capys">
            <div className=" mt-3 mb-3 col-12 mr-0 ml-0 pr-0 pl-0 card card-custom p-2 mt-2">
                <div className="d-flex justify-content-center align-items-center flex-column">
                    {!handleFormatoSRC() && (
                        <>
                            <h5>Favor Assinar</h5>

                            <div className="border border-secondary" id="">
                                <SignaturePad
                                    canvasProps={{
                                        width: 400,
                                        height: 145,
                                        className: "sigCanvas",
                                    }}
                                    ref={padRef}
                                />
                            </div>
                        </>
                    )}
                </div>

                <div className="d-flex flex-column align-items-center justify-content-center">
                    <h5>Assinatura</h5>
                    <div className="border border-secondary">
                        {assinaturaFormularioImg ? (
                            <>
                                <img
                                    className={"sigImage"}
                                    src={handleFormatoSRC()}
                                    alt="Assinatura do usúario"
                                    style={{
                                        height: 150,
                                        width: 400,
                                        resize: "initial",
                                    }}
                                />
                            </>
                        ) : (
                            <img
                                className={"sigImage"}
                                src={imagemInicial}
                                alt="Assinatura do usúario em branco"
                                style={{
                                    height: 150,
                                    width: 400,
                                    resize: "initial",
                                }}
                            />
                        )}
                    </div>
                </div>

                {!handleFormatoSRC() && (
                    <div className="d-flex justify-content-around col-12 mt-2 mb-2">
                        <button
                            className="btn btn-outline-danger"
                            type="button"
                            onClick={() => clear()}
                            style={{ width: 80, height: 40 }}
                        >
                            Apagar
                        </button>
                        <button
                            className="btn btn-outline-primary"
                            type="button"
                            onClick={() => trim()}
                            disabled={salvarAssinaturaLoading}
                            style={{ width: 90, height: 40 }}
                        >
                            {salvarAssinaturaLoading ? (
                                <>
                                    <span>Assinar</span>
                                    <Spinner size="sm" />
                                </>
                            ) : (
                                <span>Assinar</span>
                            )}
                        </button>
                    </div>
                )}
            </div>
        </OrSpinner>
    );
}
